











import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import {
  authorsDropdownModule,
  loadAuthors,
  $authors,
} from '@/pages/dictionary/themes/list/parts/themes-filter/parts/authors-dropdown/authors-dropdown.model'
import { DropdownItem } from '@/pages/common/types'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  effector: {
    $authors,
    ...authorsDropdownModule.store,
  },
  methods: {
    ...authorsDropdownModule.methods,
    loadAuthors,
    onSelectItem(item: DropdownItem | null) {
      this.$emit('setItem', item ? item.name : null)
    },
  },
  mounted() {
    loadAuthors()
  },
})
